import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/services/services-what-we-offer.svg")